import { Box } from '@mui/material';
import { useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { CommonDatagrid } from '..';
import { IRootState, ICustomerRefundRequest } from '../../../types/store';
import { getCustomerRefundColumns } from './columns';
import { RefreshButton } from '../../Buttons/RefreshButton';
import { ProcessRefundDialog } from '../../Dialog/ProcessRefundDialog';
import { ICustomerRefundDatagridProps } from '../../../types/commonDatagrid';

export const CustomerRefundDatagrid = ({ reload }: ICustomerRefundDatagridProps) => {
  const { content } = useSelector((state: IRootState) => state.customerRefund);
  const [selectedRefund, setSelectedRefund] = useState<ICustomerRefundRequest | null>(null);
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  const onClickView = (row: ICustomerRefundRequest) => {
    setSelectedRefund(row);
    setIsDialogOpen(true);
  };

  const columns = useMemo(() => getCustomerRefundColumns(onClickView), []);

  return (
    <>
      <CommonDatagrid
        data={content}
        columns={columns}
        rowId="id"
        headerActionButtons={
          <Box display="flex" sx={{ gap: 2 }}>
            <RefreshButton onClick={reload} />
          </Box>
        }
        searchbarPlaceholder="Search by order number or customer"
        searchKey="order_number"
      />
      <ProcessRefundDialog
        selectedRefund={selectedRefund}
        isOpen={isDialogOpen}
        setIsOpen={setIsDialogOpen}
        onProcessed={reload}
      />
    </>
  );
};
